import {
  applyPhoneMask,
  COUNTRIES_REGIONAL_CONFIG,
  getDefaultPhonePrefix,
  getPhoneNationalDigitCount,
  isPhoneMinLength,
} from '@wareclouds/frontend-common';

import { CONTEXT } from '../../../../config/consts/commons';

function getCurrentIntlCode() {
  return COUNTRIES_REGIONAL_CONFIG[CONTEXT]?.intlCode ?? '+55';
}

function getCurrentDialDigits() {
  return getCurrentIntlCode().replace(/\D/g, '');
}

export function getDefaultProfilePhonePrefix() {
  return getDefaultPhonePrefix(CONTEXT);
}

export function applyProfilePhoneMask(raw) {
  return applyPhoneMask(raw, CONTEXT);
}

export function profilePhoneNationalDigitCount(masked) {
  return getPhoneNationalDigitCount(masked, CONTEXT);
}

export function isProfilePhoneMinLength(masked) {
  return isPhoneMinLength(masked, CONTEXT);
}

export function normalizeProfilePhoneForApi(masked) {
  const d = String(masked ?? '').replace(/\D/g, '');
  const dialDigits = getCurrentDialDigits();
  const full = d.startsWith(dialDigits) ? d : `${dialDigits}${d}`;
  return `+${full}`;
}
